<template>
  <div :class="{ 'header-left-wrap': true, 'header-content-show': isMenuHide }">
    <div class="header-left-bg" @click="handleHide"></div>
    <div
      :class="{ 'header-left-content ': true, 'header-left-content-show': isMenuHide }"
    >
      <div class="header-left-top">
        <div class="header-left-user">
          <router-link
            v-if="userInfo.id"
            :to="{ name: 'Mine' }"
          >
            <img
              :src="
                userInfo.userImg ||
                'https://shijiaoke.oss-cn-beijing.aliyuncs.com/public/not_loaded.jpg'"
              @click="toSignin"
            />
          </router-link>
          <!-- <img src="https://beinabncc.oss-cn-beijing.aliyuncs.com/News/1e0ba2777e56d0e72327afb20bcb792a.jpg" v-else @click="toLogin" /> -->
          <img src="https://beinabncc.oss-cn-beijing.aliyuncs.com/News/72bd4bed20c9be16bbe779d66699e17c.jpg" v-else @click="toLogin" />
        </div>
        <div class="header-left-text">
          <span v-if="userInfo.id">{{ userInfo.nickName }}</span>
          <span @click="toLogin" v-else>未登录</span>
          <p v-if="userInfo.id">{{ userInfo.personalSignature }}</p>
          <p @click="toLogin" v-else>点击登录</p>
        </div>
        <router-link
          class="header-left-sign"
          :to="{ name: 'signIn' }"
          v-if="userInfo.id"
          @click="toSignin"
          >签到</router-link
        >
        <span class="header-left-sign" @click="toLogin" v-else>签到</span>
      </div>
      <div class="header-left-main-wapper">
        <div>
          <ul class="header-left-main" style="border: none">
            <li>
              <router-link
                :to="{ name: 'ProductCategory'}"
                @click="handleHide"
              >
                <img

                  src="Https://beinabncc.oss-cn-beijing.aliyuncs.com/bncc/news/icon-bw20210419.png"
                  style="left: 12px"
                />
                <span>标准物质</span>
              </router-link>
            </li>
            <li>
              <router-link
                  :to="{ name: 'specialProCategory'}"
                  @click="handleHide"
              >
                <svg style="width: 0.76rem; left: 0.2rem;" t="1612256353934" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1975" width="32" height="32"><path d="M409.38666667 570.02666667c-72.42666667 0-131.30666667-58.88-131.30666667-131.30666667 0-72.42666667 58.88-131.30666667 131.30666667-131.30666667 72.42666667 0 131.30666667 58.88 131.30666666 131.30666667 0 72.42666667-58.98666667 131.30666667-131.30666666 131.30666667z m0-219.94666667c-48.85333333 0-88.64 39.78666667-88.64 88.64s39.78666667 88.64 88.64 88.64 88.64-39.78666667 88.64-88.64-39.78666667-88.64-88.64-88.64zM833.28 454.29333333H643.73333333c-11.73333333 0-21.33333333-9.6-21.33333333-21.33333333s9.6-21.33333333 21.33333333-21.33333333h189.54666667c11.73333333 0 21.33333333 9.6 21.33333333 21.33333333s-9.6 21.33333333-21.33333333 21.33333333zM833.28 556.37333333H643.84c-11.73333333 0-21.33333333-9.6-21.33333333-21.33333333s9.6-21.33333333 21.33333333-21.33333333h189.54666667c11.73333333 0 21.33333333 9.6 21.33333333 21.33333333-0.10666667 11.73333333-9.70666667 21.33333333-21.44 21.33333333z" p-id="1976" fill="#df0024"></path><path d="M726.72 685.22666667l-138.34666667 221.86666666c-6.18666667 9.92-19.41333333 13.01333333-29.44 6.82666667-9.92-6.18666667-13.01333333-19.41333333-6.82666666-29.44l138.34666666-221.86666667c6.18666667-9.92 19.41333333-13.01333333 29.44-6.82666666 10.02666667 6.18666667 13.01333333 19.41333333 6.82666667 29.44z" p-id="1977" fill="#df0024"></path><path d="M909.01333333 94.29333333H114.45333333c-18.77333333 0-34.13333333 15.36-34.13333333 34.13333334v766.82666666c0 18.77333333 15.36 34.13333333 34.13333333 34.13333334h71.36v-42.66666667h-62.82666666V136.96h777.49333333v749.76h-67.73333333v42.66666667h76.26666666c18.77333333 0 34.13333333-15.36 34.13333334-34.13333334V128.42666667c0-18.77333333-15.36-34.13333333-34.13333334-34.13333334z" p-id="1978" fill="#df0024"></path><path d="M276.58666667 755.73333333c0-68.16 55.46666667-123.52 123.52-123.52h17.70666666c68.16 0 123.52 55.46666667 123.52 123.52l0.96 152c0.53333333 11.2 9.81333333 20.05333333 20.8 20.26666667 11.30666667 0.21333333 21.01333333-8.74666667 21.54666667-20.26666667-0.21333333-50.66666667-0.42666667-101.33333333-0.74666667-152 0-91.62666667-74.56-166.18666667-166.18666666-166.18666666H400c-91.62666667 0-166.18666667 74.56-166.18666667 166.18666666 0.10666667 50.66666667 0.32 101.33333333 0.42666667 152-0.21333333 11.52 9.06666667 21.22666667 20.58666667 21.33333334 11.52 0.10666667 21.01333333-9.28 21.12-20.8l0.64-152.53333334z" p-id="1979" fill="#df0024"></path></svg>
                <span>产品专项</span>
              </router-link>
            </li>
            <li>
              <router-link @click="handleHide" :to="{ name: 'customize' }">
                <img
                  src="https://shijiaoke.oss-cn-beijing.aliyuncs.com/News/m-home-dz20201027.png"
                  style="width: 0.6rem"
                />
                <span>标准物质定制</span>
              </router-link>
            </li>
          </ul>
          <ul class="header-left-main">
            <li>
              <router-link @click="handleHide" :to="{ name: 'News'}">
                <img
                  style="width: 0.6rem"
                  src="@/assets/img/leftNav/icon12.png"
                />
                <span>新闻资讯</span>
              </router-link>
            </li>
            <li>
              <router-link @click="handleHide" :to="{ name: 'Course' }">
                <img
                  style="width: 0.6rem"
                  src="@/assets/img/leftNav/icon13.png"
                />
                <span>直播间</span>
              </router-link>
            </li>
            <li>
              <router-link @click="handleHide" :to="{ name: 'Course' , query:{type:206} }">
                <!-- <img
                  style="width: 0.76rem; left: 0.2rem;"
                  src="https://shijiaoke.oss-cn-beijing.aliyuncs.com/Course/peixunzhongxin20210126.png"
                /> -->
                <svg style="width: 0.76rem; left: 0.2rem;" t="1612256353934" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1975" width="32" height="32"><path d="M409.38666667 570.02666667c-72.42666667 0-131.30666667-58.88-131.30666667-131.30666667 0-72.42666667 58.88-131.30666667 131.30666667-131.30666667 72.42666667 0 131.30666667 58.88 131.30666666 131.30666667 0 72.42666667-58.98666667 131.30666667-131.30666666 131.30666667z m0-219.94666667c-48.85333333 0-88.64 39.78666667-88.64 88.64s39.78666667 88.64 88.64 88.64 88.64-39.78666667 88.64-88.64-39.78666667-88.64-88.64-88.64zM833.28 454.29333333H643.73333333c-11.73333333 0-21.33333333-9.6-21.33333333-21.33333333s9.6-21.33333333 21.33333333-21.33333333h189.54666667c11.73333333 0 21.33333333 9.6 21.33333333 21.33333333s-9.6 21.33333333-21.33333333 21.33333333zM833.28 556.37333333H643.84c-11.73333333 0-21.33333333-9.6-21.33333333-21.33333333s9.6-21.33333333 21.33333333-21.33333333h189.54666667c11.73333333 0 21.33333333 9.6 21.33333333 21.33333333-0.10666667 11.73333333-9.70666667 21.33333333-21.44 21.33333333z" p-id="1976" fill="#df0024"></path><path d="M726.72 685.22666667l-138.34666667 221.86666666c-6.18666667 9.92-19.41333333 13.01333333-29.44 6.82666667-9.92-6.18666667-13.01333333-19.41333333-6.82666666-29.44l138.34666666-221.86666667c6.18666667-9.92 19.41333333-13.01333333 29.44-6.82666666 10.02666667 6.18666667 13.01333333 19.41333333 6.82666667 29.44z" p-id="1977" fill="#df0024"></path><path d="M909.01333333 94.29333333H114.45333333c-18.77333333 0-34.13333333 15.36-34.13333333 34.13333334v766.82666666c0 18.77333333 15.36 34.13333333 34.13333333 34.13333334h71.36v-42.66666667h-62.82666666V136.96h777.49333333v749.76h-67.73333333v42.66666667h76.26666666c18.77333333 0 34.13333333-15.36 34.13333334-34.13333334V128.42666667c0-18.77333333-15.36-34.13333333-34.13333334-34.13333334z" p-id="1978" fill="#df0024"></path><path d="M276.58666667 755.73333333c0-68.16 55.46666667-123.52 123.52-123.52h17.70666666c68.16 0 123.52 55.46666667 123.52 123.52l0.96 152c0.53333333 11.2 9.81333333 20.05333333 20.8 20.26666667 11.30666667 0.21333333 21.01333333-8.74666667 21.54666667-20.26666667-0.21333333-50.66666667-0.42666667-101.33333333-0.74666667-152 0-91.62666667-74.56-166.18666667-166.18666666-166.18666666H400c-91.62666667 0-166.18666667 74.56-166.18666667 166.18666666 0.10666667 50.66666667 0.32 101.33333333 0.42666667 152-0.21333333 11.52 9.06666667 21.22666667 20.58666667 21.33333334 11.52 0.10666667 21.01333333-9.28 21.12-20.8l0.64-152.53333334z" p-id="1979" fill="#df0024"></path></svg>
                <span>培训中心</span>
              </router-link>
            </li>
            <li>
              <router-link @click="handleHide" :to="{ name: 'Topic' }">
                <img
                  style="width: 0.6rem"
                  src="@/assets/img/leftNav/icon_fatie.png"
                />
                <span>交流区</span>
              </router-link>
            </li>
            <li>
              <router-link @click="handleHide" :to="{ name: 'Library', query: { type: 2 } }">
                <img
                  style="width: 0.6rem"
                  src="@/assets/img/leftNav/icon15.png"
                />
                <span>文库</span>
              </router-link>
            </li>
          </ul>
          <ul class="header-left-main">
            <li>
              <router-link @click="handleHide" :to="{ name: 'About'}">
                <img
                  style="width: 0.707rem"
                  src="@/assets/img/icon_phone.svg"
                />
                <span>联系我们</span>
              </router-link>
            </li>
            <li>
              <router-link @click="handleHide" :to="{ name: 'ShopCar'}">
                <img
                  style="width: 0.6rem"
                  src="@/assets/img/common/icon23-1.png"
                />
                <span>购物车</span>
              </router-link>
            </li>
            <li>
              <router-link @click="handleHide" :to="{ name: 'Index'}">
                <img
                  style="width: 0.6rem"
                  src="@/assets/img/icon22.png"
                />
                <span>返回主页</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  props: {
    isMenuHide: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const hide = inject("handleMenuHide");
    const isHeaderHide = inject("isHeaderHide")
    const router = useRouter();
    const route = useRoute();
    function handleHide() {
      (hide as () => void)();
    }

    //  展示用户信息
    const userInfo = inject("userInfo") as any;
    function toLogin() {
      (hide as () => void)();
      if(route.path != "/login"){
        // router.push({
        //   name: "Login",
        //   query: {
        //     redirect: route.fullPath
        //   }
        // })
        router.push({
          name: "Mine",
        })
      }else{
        // router.push({
        //   name: "Login",
        // })
        router.push({
          name: "Mine",
        })
      }

    }

    function toSignin() {
        (hide as () => void)();
    }

    return {
      handleHide,
      toLogin,
      userInfo,
      toSignin
    };
  },
});
</script>

<style lang="scss" scoped>
/* 头部侧边栏弹出窗 start*/
.header-left-wrap {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 10000;
  overflow: hidden;
  transform: translateX(-100%);
}
.header-content-show {
  transform: translateX(0);
}

.header-left-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
  /* // opacity: 0; */
  opacity: 1;
}

.header-left-content {
  width: 274.988px;
  background-color: #fff;
  overflow: hidden;
  position: absolute;
  /* // left: -100%; */
  left: 0;
  transform: translateX(-274.988px);
  z-index: 1000;
  top: 0;
  height: 100%;
  overflow-y: scroll;
  transition: transform 0.3s;
}
.header-left-main-wapper {
  height: 80%;
  padding-bottom: 154.988px;
  box-sizing: border-box;
  overflow-y: scroll;
}

.header-left-content-show {
  transform: translateX(0);
  transition: transform 0.5s;
}

.header-left-top {
  width: 100%;
  height: 105px;
  background-color: #d64b4b;
  box-sizing: border-box;
  padding-left: 10.013px;
  overflow: hidden;
  padding-right: 10.013px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;
}

.header-left-user {
  display: block;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  overflow: hidden;
  float: left;
}

.header-left-user img {
  width: 100%;
  height: 100%;
}

.header-left-text {
  width: 115.013px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 15px;
  color: #ffffff;
}

.header-left-text span {
  font-size: 16.012px;
  color: #ffffff;
}

.header-left-text p {
  width: 100%;
  color: #ffffff;
  font-size: 12px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-left-sign {
  display: block;
  width: 67.987px;
  height: 30px;
  border-radius: 15px;
  border: solid 1.012px #ffffff;
  line-height: 30px;
  text-align: center;
  color: #ffffff;
  font-size: 13.988px;
  box-sizing: border-box;
}

.header-left-main {
  width: 100%;
  margin-top: 4.988px;
  /* padding-top: 10.013px; */
  border-top: 2px solid #f4f4f4;
}

.header-left-main li {
  width: 100%;
  height: 42px;
  line-height: 42px;
  box-sizing: border-box;
  padding: 0 10.013px;
  padding-left: 49.987px;
  position: relative;
}

.header-left-main img, .header-left-main svg {
  width: 17.512px;
  height: auto;
  border: none;
  position: absolute;
  left: 10.013px;
  top: 50%;
  transform: translateY(-40%);
}

.header-left-main li span {
  color: #666666;
  font-size: 16.012px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  top: -2px;
}
/* 头部侧边栏弹出窗 end*/
</style>
